e.A.notification_settings = {
	init: function(){
		$('#notifications_submit').click(function(){
			e.A.notification_settings._send_data();
		});
	},

	_send_data : function(){
		EdSpireAjax.Request('EdSpireAccountSettings',  'ajax_update_notification_settings', $e('#notification-settings-form').serializeArray(), function(){
			e.A.Messages.display_message( 'notifications_updated' );
		});
	}
};